// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2343":"a51ff52e","4036":"1119e94c","4891":"0d0a4478"}[chunkId] + ".chunk.css";
};